module.exports = __webpack_public_path__ + "static/img/produtos_p.3b3fe17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/limao/produtos_p.png
// module id = h7im
// module chunks = 0